export default __webpack_public_path__ + "static/media/telasinox.81d286f7.png";